<template>
  <div class="slideshow-wrapper">
    <div
      class="slideshow-photos"
      @mouseenter="markHovering(true)"
      @mouseleave="markHovering(false)"
    >
      <transition name="fade" v-for="(slide, index) in slides" :key="slideKey(slide, index)">
        <a
          :class="['slideshow-photo', { 'is-video': isVideoSlide(slide) }]"
          :style="`background-image: url(${slideImageUrl(slide)});`"
          v-if="checkActive(index)"
          :href="slide['url']"
          :target="videoLinkTarget(slide)"
          :rel="videoLinkRel(slide)"
          :aria-label="videoAriaLabel(slide)"
        ></a>
      </transition>
    </div>
    <ul class="slideshow-titles">
      <li
        v-for="(slide, index) in slides"
        :key="index"
        :class="{ active:checkActive(index) }"
        @mouseover="setSlide(index); markHovering(true);"
        @mouseleave="markHovering(false)"
      >
        <a
          :href="slide['url']"
          :target="videoLinkTarget(slide)"
          :rel="videoLinkRel(slide)"
        >{{ truncatedTitle(index) }}</a>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:math';

$photo-height: 530;
$photo-width: 860;
$photo-relative-width: 0.58;
$photo-relative-width-calc: percentage($photo-relative-width);
$titles-relative-width-calc: percentage(1 - ($photo-relative-width));
$slideshow-photo-ratio-small: percentage(math.div($photo-height, $photo-width));
$slideshow-photo-ratio: percentage(math.div(math.div($photo-height, $photo-width), math.div(1,$photo-relative-width)));
$brand-blue: #002395;
$small: 900px;

.slideshow-wrapper {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  @media screen and (min-width: $small) { flex-wrap: wrap; }
  border-top: 4px solid $brand-blue;

  .slideshow-photos {
    display: block;
    position: relative;
    width: 100%;
    @media screen and (min-width: $small) { width: $photo-relative-width-calc; }
    padding: 0;
    margin: 0;
    padding-bottom: $slideshow-photo-ratio-small;
    @media screen and (min-width: $small) { padding-bottom: $slideshow-photo-ratio; }
    background-color: #9a9a9a;

    .slideshow-photo {
      position: absolute;
      top: 0; bottom: 0; left: 0; right: 0;
      background-size: cover;
      background-position: 50% 50%;
    }
  }

  .slideshow-titles {
    width: 100%;
    @media screen and (min-width: $small) { width: $titles-relative-width-calc; }
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      flex: 1;
      margin: 0;
      padding: 1rem 0;
      @media screen and (min-width: $small) { padding: 1rem 1.5rem; }
      font-size: 1.2rem;
      @media screen and (min-width: $small) { font-size: 1.3rem; }
      border-bottom: 1px solid #9a9a9a;
      line-height: 1.3;

      a {
        color: #848889;
        text-decoration: none;

        &:hover { color: #002395; }
      }

      &.active a {
        color: $brand-blue;
      }

      &:last-child {
        border-bottom: 0;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

</style>

<script>
// import HelloWorld from './components/HelloWorld.vue'

export default {
  name: 'App',
  components: {
    // HelloWorld
  },

  data() {
    return {
      currentSlide: 0,
      hovering: false,
    }
  },

  mounted: function () {
    this.slides.forEach((slide) => {
      const src = this.slideImageUrl(slide)
      if (!src) {
        return
      }
      const image = new Image()
      image.src = src
    })

    let self = this
    window.setInterval(() => {
      if(!self.hovering && self.slides.length > 1) {
        self.goToNextSlide()
      }
    }, this.slideSpeed * 1000)
  },

  methods: {
    goToNextSlide() {
      this.currentSlide = this.currentSlide < (this.slides.length - 1) ? this.currentSlide + 1 : 0;
      // console.log(`Slide: ${this.currentSlide}`)
    },

    markHovering(value) {
      this.hovering = value
    },

    setSlide(index) {
      this.currentSlide = index
    },

    checkActive(index) {
      return this.currentSlide === index
    },

    truncatedTitle(index, length = 70) {
      const fullTitle = (this.slides[index] && this.slides[index].title) ? String(this.slides[index].title) : ''
      return fullTitle.substring(0,length) + ( fullTitle.length > length ? '...' : '');
    },

    slideKey(slide, index) {
      return (slide && slide.url) ? slide.url : String(index)
    },

    slideImageUrl(slide) {
      const img = slide && slide.img ? String(slide.img) : ''
      return img.replace('www', 'cdn')
    },

    isVideoSlide(slide) {
      if (!slide || typeof slide !== 'object') {
        return false
      }
      const value = slide.is_video
      return value === true || value === 1 || value === '1' || value === 'true'
    },

    videoLinkTarget(slide) {
      return this.isVideoSlide(slide) ? '_blank' : undefined
    },

    videoLinkRel(slide) {
      return this.isVideoSlide(slide) ? 'noopener noreferrer' : undefined
    },

    videoAriaLabel(slide) {
      if (!this.isVideoSlide(slide)) {
        return undefined
      }

      return slide.title ? `Video: ${slide.title}` : 'Video'
    }
  },

  computed: {
    slides: function() {
      try {
        const parsed = JSON.parse(this.slidesJson || '[]')
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    }
  },

  props: {
    slideSpeed: {
      type: Number,
      default: 4,
    },
    slidesJson: {
      type: String,
      default: '',
    }
  }
}
</script>
